var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 16.1967 4.58521 19.7896 8.25 21.2731V15C8.25 12.929 9.92893 11.25 12 11.25H15.3299L13.2648 8.92686C12.9897 8.61727 13.0175 8.14322 13.3271 7.86803C13.6367 7.59284 14.1108 7.62073 14.386 7.93032L17.5606 11.5017C17.8131 11.7859 17.8131 12.2141 17.5606 12.4983L14.386 16.0697C14.1108 16.3793 13.6367 16.4072 13.3271 16.132C13.0175 15.8568 12.9897 15.3828 13.2648 15.0732L15.3299 12.75H12C10.7574 12.75 9.75 13.7574 9.75 15V21.7459C10.4732 21.9121 11.2263 22 12 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlt);
export default __webpack_public_path__ + "static/media/right-alt.83c2d543f8b5016dc2838b88296a2959.svg";
export { ForwardRef as ReactComponent };